const countries = {
    uk: 'UK',
    de: 'DE'
} as const;

const countryProvider: { country: 'UK' | 'DE' } = {
    country: 'UK'
};

export function setCountry(countryCode: keyof typeof countries) {
    countryProvider.country = countries[countryCode];
}

export function getCountry() {
    return countryProvider.country;
}
